import type { TPartner } from "./partner";

// TYPES ----------------------------------------

export type TScholarshipStatus =
  (typeof ScholarshipStatus)[keyof typeof ScholarshipStatus];

export type TScholarship = {
  _id?: string;
  author?: string;
  childrenUnder18?: string;
  createdAt?: string;
  dependentAdults?: string;
  highestHouseholdEducationLevel?: string;
  honestyPledge?: false | "yes";
  lunchProgram?: false | "yes";
  medicaid?: false | "yes";
  otherGovernmentBenefits?: false | "yes";
  otherGovernmentBenefitsDetails?: string;
  partner?: TPartner;
  pellGrant?: false | "yes";
  publicHousing?: false | "yes";
  satRegistrationFeeWaiver?: boolean;
  snap?: false | "yes";
  ssdi?: false | "yes";
  statement?: string;
  status?: TScholarshipStatus;
  typeOfSchool?: string;
  unsureBenefits?: false | "yes";
  firstName: string;
  lastName: string;
};

// ENUM -----------------------------------------

export const ScholarshipStatus = {
  AdminCompleted: "adminCompleted",
  Approved: "approved",
  Denied: "denied",
  OnHoldCX: "onHoldCX",
  OnHoldUser: "onHoldUser",
  PendingReview: "pendingReview",
} as const;

// HELPERS --------------------------------------

export function scholarshipIsUnstarted(status?: TScholarshipStatus) {
  return !status;
}

export function scholarshipIsPendingReview(status?: TScholarshipStatus) {
  return (
    status === ScholarshipStatus.PendingReview ||
    status === ScholarshipStatus.OnHoldCX ||
    status === ScholarshipStatus.OnHoldUser
  );
}

export function scholarshipIsApproved(status?: TScholarshipStatus) {
  return (
    status === ScholarshipStatus.Approved ||
    status === ScholarshipStatus.AdminCompleted
  );
}

export function scholarshipIsDenied(status?: TScholarshipStatus) {
  return status === ScholarshipStatus.Denied;
}
